import { Search, FileSpreadsheet, ExternalLink } from "lucide-react";
import { Input } from "@/components/ui/input";
import { SelectBox } from "@/components/Inputs";

// KolayBi liste çubuğu: alan seçici + arama + Excel İşlemleri
export const AraCubugu = ({ alanlar, alan, setAlan, q, setQ, onExcel, testid, sol }) => (
  <div className="flex flex-wrap items-center gap-2 mb-3">
    {sol}
    <div className="ml-auto flex flex-wrap gap-2 w-full sm:w-auto">
      {alanlar && <div className="w-36"><SelectBox testid={`${testid}-alan`} value={alan} onChange={setAlan} options={Object.entries(alanlar).map(([value, label]) => ({ value, label }))} /></div>}
      <div className="relative flex-1 sm:w-64 sm:flex-none min-w-0">
        <Search className="w-4 h-4 absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input data-testid={`${testid}-ara`} placeholder={alanlar ? alanlar[alan] : "Ara"} value={q} onChange={(e) => setQ(e.target.value)} className="pr-9 bg-white/5" />
      </div>
      {onExcel && <button data-testid={`${testid}-excel`} onClick={onExcel} className="inline-flex items-center gap-1.5 px-3 h-10 rounded-lg text-xs font-semibold border border-emerald-500/40 text-emerald-400 hover:bg-emerald-500/10"><FileSpreadsheet className="w-4 h-4" />Excel İşlemleri</button>}
    </div>
  </div>
);

export const Th = ({ children, right, className = "" }) => <th className={`p-2.5 text-xs font-semibold bg-white/[0.04] ${right ? "text-right" : "text-center"} ${className}`}>{children}</th>;

export const DetayIkon = () => <ExternalLink className="w-4 h-4 text-[var(--g1)]" />;

const TON = { gri: "border border-white/25 text-foreground/80", yesil: "bg-emerald-500/15 text-emerald-400 border border-emerald-500/30", kirmizi: "bg-red-500/80 text-white",
  mavi: "bg-blue-600/80 text-white", sari: "bg-amber-500/20 text-amber-300 border border-amber-500/30" };
export const Rozet = ({ ton = "gri", children, testid }) => <span data-testid={testid} className={`inline-block text-[10px] px-1.5 py-0.5 rounded whitespace-nowrap ${TON[ton]}`}>{children}</span>;

export const BosDurum = ({ testid, text = "Veri yok" }) => (
  <div className="py-16 flex flex-col items-center gap-2 text-sm text-muted-foreground" data-testid={testid}>
    <div className="w-14 h-10 rounded-md bg-white/10" />{text}
  </div>
);

export const trAra = (s) => String(s || "").replace(/[İI]/g, "i").replace(/ı/g, "i").toLowerCase();
export const bugun = () => new Date().toISOString().slice(0, 10);
